module.exports = __webpack_public_path__ + "img/tp-radar.2509f88a.png";